import './AudioSource.css';
import { useState, useEffect } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import IconButton from '../Button/IconButton/IconButton';
import storage from '/src/utils/storage';

const AudioSource = ({ src, picture,downloadUrl }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  downloadUrl = downloadUrl == null ? src : downloadUrl;
  useEffect(() => {
    let active = true;
    let objectUrl = null;

    const loadBlob = async () => {
      try {
        const token = storage('local').get('token');
        const response = await fetch(src, {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });
    
        if (!response.ok) {
          const text = await response.text();
          console.error("Erreur fetch :", text);
          throw new Error(`HTTP ${response.status}`);
        }
    
        const blob = await response.blob();
        objectUrl = URL.createObjectURL(blob);
    
        if (active) {
          setBlobUrl(objectUrl);
        }
    
      } catch (e) {
        console.error("Erreur chargement blob audio :", e);
      }
    };
    

    loadBlob();

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (!blobUrl) return null;

  return (
    <div className="audio-container">
      <AudioPlayer src={blobUrl} autoPlay={false} />
      {/* download button */}
      <div className="download_button_container">
      <a href={downloadUrl} className="download_audio_source" download > 
        <IconButton icon={"fas fa-download"} className="download_button_audio"/> 
        </a>
      </div>
    </div>
  );
};


export default AudioSource;


